<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--생산법인-->
							<th class="col-1">{{ getMessage_('QWCC001546') }}</th>
							<td class="col-1">
								{{ masterInfo.htwoCorpNm }}
							</td>
							<!--생산공장-->
							<th class="col-1">{{ getMessage_('QWCC001540') }}</th>
							<td class="col-1">
								{{ masterInfo.plntNm }}
							</td>
							<!--연료전지사양-->
							<th class="col-1">{{ getMessage_('QWCC001021') }}</th>
							<td class="col-1">
								{{ masterInfo.flclSpcNm }}
							</td>
							<!--HTWO 생산일-->
							<th class="col-1">{{ getMessage_('QWCC001999') }}</th>
							<td class="col-1">
								{{ masterInfo.erpProdDd }}
							</td>
						</tr>

						<tr>
							<!--차량구분-->
							<th class="col-1">{{ getMessage_('QWCC001015') }}</th>
							<td class="col-1">
								{{ masterInfo.carScnNm }}
							</td>
							<!--제품유형-->
							<th class="col-1">{{ getMessage_('QWCC002001') }}</th>
							<td class="col-1">
								{{ masterInfo.carTypeNm }}
							</td>
							<!--VIN No.-->
							<th class="col-1">VIN No.</th>
							<td class="col-1">
								{{ masterInfo.carVin }}
							</td>
							<!--HTWO 판매일-->
							<th class="col-1">{{ getMessage_('QWCC001044') }}</th>
							<td class="col-1">
								{{ masterInfo.erpSaleDd }}
							</td>
						</tr>

						<tr>
							<!--제품 Id-->
							<th class="col-1">{{ getMessage_('QWCC001538') }}</th>
							<td class="col-1">
								{{ masterInfo.pmcId }}
							</td>
							<!--제품 No.-->
							<th class="col-1">{{ getMessage_('QWCC001721') }}</th>
							<td class="col-1">
								{{ masterInfo.pmcNo }}
							</td>
							<!--동력유형-->
							<th class="col-1">{{ getMessage_('QWCC001018') }}</th>
							<td class="col-1">
								{{ masterInfo.pwrTypeNm }}
							</td>
							<!--JV 판매일-->
							<th class="col-1">{{ getMessage_('QWCC001010') }}</th>
							<td class="col-1">
								{{ masterInfo.jvSaleDd }}
							</td>
						</tr>
						<tr>
							<!--HTWO 보증조건-->
							<th class="col-1">{{ getMessage_('QWCC001188') }}</th>
							<td class="col-1">
								{{ masterInfo.zwPeriodMilg }}
							</td>
							<!--고객사-->
							<th class="col-1">{{ getMessage_('QWCC001452') }}</th>
							<td class="col-1">
								{{ masterInfo.custNm }}
							</td>
							<!--판매국가-->
							<th class="col-1">{{ getMessage_('QWCC001542') }}</th>
							<td class="col-1">
								{{ masterInfo.saleNatNm }}
							</td>
							<!--OEM판매일-->
							<th class="col-1">{{ getMessage_('QWCC001012') }}</th>
							<td class="col-1">
								{{ masterInfo.oemSaleDd }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	data() {
		return {
			input1: '',
			pprNo: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		await this.getCommCodes_({ key: 'tymaCdList', codeType: 'FLCL_SPC_CST' }); //기종;
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>
